import React from 'react';
import EditorSwap from '@wix/da-ds/pkg/Icons/24x24/EditorSwap';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenuV2/IconButtonWithContextMenu';
import { useTranslation } from 'react-i18next';
import { TOOLTIP_HOVER_DELAY } from '../../../../constants';
import EditorLink from '@wix/da-ds/pkg/Icons/24x24/EditorLink';
import EditorImage from '@wix/da-ds/pkg/Icons/24x24/EditorImage';
const Convert = ({ editor })=>{
    const { t } = useTranslation('editor');
    return /*#__PURE__*/ React.createElement(IconButtonWithContextMenu, {
        tooltipText: t('ext.deviation.toolbar.convert'),
        tooltipHoverDelay: TOOLTIP_HOVER_DELAY,
        icon: EditorSwap,
        items: [
            {
                label: t('ext.deviation.toolbar.convert.toLink'),
                icon: /*#__PURE__*/ React.createElement(EditorLink, null),
                onClick: ()=>{
                    editor.chain().focus().daDeviationToLink().run();
                }
            },
            {
                label: t('ext.deviation.toolbar.convert.toThumb'),
                icon: /*#__PURE__*/ React.createElement(EditorImage, null),
                onClick: ()=>{
                    editor.chain().focus().daDeviationConvertToThumb().run();
                }
            }
        ],
        size: "medium"
    });
};
Convert.displayName = 'Convert';
export default Convert;

//# sourceMappingURL=Convert.js.map